import { GetRateParameters, useRepositoryQuery } from '@mews-commander/data-access';
import { Optional } from '@mews/std';

type UseRateGroupOfRateParams = Omit<GetRateParameters, 'rateIds'> & {
    rateId: Optional<string>;
};

export const useRateGroupOfRate = ({ rateId, ...other }: UseRateGroupOfRateParams) =>
    useRepositoryQuery(
        'rates',
        'getAll',
        { ...other, rateIds: [rateId || ''] },
        {
            select: ({ rates, rateGroups }) => {
                const rate = rates ? rates.find(({ id }) => id === rateId) : undefined;
                const rateGroup = rate && rateGroups ? rateGroups.find(({ id }) => id === rate.rateGroupId) : undefined;

                return { rateGroup };
            },
            enabled: !!rateId,
        }
    );
